import { LoadState } from "../../constants/enums";
import {
  IMasterQuickReplyTemplate,
  IMasterQuickReplyTemplateData,
  IMasterQuickReplyTemplateState,
} from "./masterQuickReplyTemplate.types";
// Types


export const initialMasterQuickReplyTemplate: IMasterQuickReplyTemplate = {
  company_outlet_uuid: "",
  company_outlet_name: "",
  name: null,
  status: null,
  reason: null,
  header: null,
  body: null,
  template_id: null,
  components: [],
  template_for: [],
  text: "",
};

export const INITIAL_MASTER_QUICK_REPLY_TEMPLATE_DATA: IMasterQuickReplyTemplateData = {
  name: "",
  category: "public",
  components: [],
  example: {
    header_text: [],
    body_text: [],
  },
  header: {
    type: "HEADER",
    format: null,
    text: null,
    example: {
      header_text: [],
      header_handle: null,
    },
  },
  body: {
    type: "BODY",
    text: "",
    example: {
      body_text: [],
    },
  },
  buttons: {
    type: "BUTTONS",
    buttons: [],
  },
  footer: {
    type: "FOOTER",
    text: "",
  },

  company_outlet_uuid: "",
  quick_reply_uuid: null,
  text: "",
};

export const initialMasterQuickReplyTemplateData: IMasterQuickReplyTemplateData = {
  company_outlet_uuid: "",
  name: "",
  category: "public",
  template_for: [],
  example: {
    header_text: [],
    body_text: [],
  },
  components: [],
  header: {
    type: "HEADER",
    format: null,
    text: null,
    example: {
      header_text: [],
      header_handle: null,
    },
  },
  body: {
    type: "BODY",
    text: "",
    example: {
      body_text: [],
    },
  },
  buttons: {
    type: "BUTTONS",
    buttons: [],
  },
  footer: {
    type: "FOOTER",
    text: "",
  },
  quick_reply_uuid: null,
  text: "",
  status: "ACTIVE",
};

export const initialMasterQuickReplyTemplateState: IMasterQuickReplyTemplateState = {
  list: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  masterQuickReplyTemplate: {
    data: initialMasterQuickReplyTemplate,
    loading: LoadState.NotLoaded,
    error: null,
  },
  masterQuickReplyTemplateData: {
    data: initialMasterQuickReplyTemplateData,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
